import { Button } from "@/components/ui/button";
import {
  DrawerContent,
  DrawerDescription,
  DrawerFooter,
  DrawerHeader,
  DrawerTitle,
} from "@/components/ui/drawer";
import { MessageSquare, X } from "lucide-react";

interface ChannelTypeSelectProps {
  onSelect: (type: "slack") => void;
  onClose: () => void;
}

export default function ChannelTypeSelect({
  onSelect,
  onClose,
}: ChannelTypeSelectProps) {
  return (
    <DrawerContent>
      <DrawerHeader>
        <DrawerTitle>Selecione o tipo de canal</DrawerTitle>
        <DrawerDescription>
          Escolha o tipo de canal que você deseja criar.
        </DrawerDescription>
      </DrawerHeader>
      <div className="grid gap-4 py-4">
        <Button
          variant="outline"
          className="h-auto py-4 flex flex-col items-center gap-2"
          onClick={() => onSelect("slack")}
        >
          <MessageSquare className="h-6 w-6 text-blue-500" />
          <span className="text-center">
            Crie um canal de atendimento
            <br />
            via Slack
          </span>
        </Button>
      </div>
      <DrawerFooter>
        <Button variant="outline" onClick={onClose}>
          <X className="mr-2 h-4 w-4" />
          Cancelar
        </Button>
      </DrawerFooter>
    </DrawerContent>
  );
}
